import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiSuperSelect } from '@elastic/eui';
import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { downloadReportsData } from '../../api/reports/downloadReportsData';
import CustomDatePicker from '../UIComponent/CustomDatePicker';
import ReportPrint from './ReportPrint';

const ReportFilters = ({
    options,
    selectedFilter,
    setSelectedFilter,
    endDate,
    startDate,
    setEndDate,
    setStartDate,
    outletString,
    reportsData,
    column,
}) => {
    const dispatch = useDispatch();
    const printerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    //FILTER OPTION FOR REPORTS

    const onChange = (selctedId) => {
        setSelectedFilter(selctedId);
    };

    //DOWNLOAD REPORTS CSV DATA
    const downloadCSV = async () => {
        setIsLoading(true);
        await dispatch(downloadReportsData(outletString, startDate, endDate, 'date', 'asc', selectedFilter));
        setIsLoading(false);
    };

    return (
        <>
            <div style={{ display: 'none' }}>
                <ReportPrint ref={printerRef} reportsData={reportsData} column={column} />
            </div>
            <EuiSpacer size='m' />
            <EuiFlexGroup direction='row' justifyContent='spaceBetween' alignItems='center' wrap>
                <EuiFlexItem style={{ minWidth: 220 }} grow={false}>
                    <EuiSuperSelect
                        options={options}
                        valueOfSelected={selectedFilter}
                        onChange={(value) => onChange(value)}
                        hasDividers
                    />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                    <EuiFlexGroup alignItems='center'>
                        {selectedFilter === 'executive_sales_summary' ? (
                            <EuiFlexItem>
                                <ReactToPrint
                                    copyStyles={false}
                                    trigger={() => (
                                        <EuiButton disabled={!reportsData?.length} fill>
                                            PRINT REPORT
                                        </EuiButton>
                                    )}
                                    content={() => printerRef.current}
                                />
                            </EuiFlexItem>
                        ) : null}
                        <EuiFlexItem>
                            <EuiButton fill isLoading={isLoading} onClick={downloadCSV}>
                                Download CSV{' '}
                            </EuiButton>
                        </EuiFlexItem>
                        <EuiFlexItem grow={2} style={{ minWidth: '280px' }}>
                            <CustomDatePicker
                                isInvalid
                                startDate={startDate}
                                setStartDate={setStartDate}
                                endDate={endDate}
                                setEndDate={setEndDate}
                                isLoading={isLoading}
                            />
                        </EuiFlexItem>
                    </EuiFlexGroup>
                </EuiFlexItem>
            </EuiFlexGroup>
            <EuiSpacer size='l' />
        </>
    );
};

export default React.memo(ReportFilters);
